import classnames from 'classnames/bind';
import style from './index.module.scss';
import { useState } from "react";
import { Address } from '../../Net/NetProtocol';
import TxtValues from '../../components/TxtValues';
const className = classnames.bind(style);
const star_icon = '/images/common/star_icon.png';

interface PropsTarget {
  userad: Address
}

const ShowAddress = (props: PropsTarget)=>{
    const {userad} = props;
    const [showWinState, setWinState] = useState(false);
    const [isshowad, setAddress] = useState(false);
    const onShow = async ()=>{
      setWinState(!showWinState);
      setAddress(!isshowad);
    }
    return(
        <div className={className('safety_center_wrap')}>
        <div className={className("safety_center_item_wrap")}>
          <div className={className('safety_center_item_title')} onClick={onShow}>
            <div className={className('left_safety_icon')}>
              <img src={star_icon} alt="star_icon" />
            </div>
            <div className={className('title_text')}>{"Shipping address"}</div>
            <div className={className('title_right_arrow', {title_right_arrow_up: showWinState})}></div>
          </div>
          <div className={className('safety_center_content_box')} style={{height: showWinState ? 'auto' : '0'}}>
            {
              isshowad &&
            <div className={className('addressinfo')}>
                <TxtValues title='fullname: ' values={userad?.fullname}/>
                <TxtValues title='phone: ' values={userad?userad.areacode+userad.phonenum:""}/>
                <TxtValues title='country: ' values={userad?.country}/>
                <TxtValues title='address: ' values={userad?.address}/>
                <TxtValues title='postcodes: ' values={userad?.postcodes}/>
            </div>
            }
          </div>
        </div>
        </div>
    )
}

export default ShowAddress;